import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-8 md:py-16 px-4 bg-slate-900 text-white text-center" data-id="element-71">
      <div className="max-w-3xl mx-auto" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/20 px-4 py-2 rounded-full mb-4" data-id="element-73">
          <span className="text-red-500 text-xs md:text-sm font-bold uppercase tracking-wider" data-id="element-74">
            🔥 OFERTA ESPECIAL DE LANZAMIENTO
          </span>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-4xl md:text-7xl font-black mb-3 leading-tight" data-id="element-75">
          MEGAPACK QUÍMICA VISUAL™ <br data-id="element-76" />
          <span className="text-blue-500" data-id="element-77">EDICIÓN LATAM</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-slate-400 text-lg md:text-2xl font-bold mb-6" data-id="element-78">
          Tu año de química, organizado y listo para enseñar. Deja de crear cada
          explicación, actividad y evaluación desde cero.
        </motion.p>

        <motion.button animate={{
        boxShadow: ['0 0 15px rgba(34,197,94,0.2)', '0 0 30px rgba(34,197,94,0.5)', '0 0 15px rgba(34,197,94,0.2)'],
        scale: [1, 1.03, 1]
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        boxShadow: {
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        },
        scale: {
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        },
        opacity: {
          delay: 0.3
        }
      }} onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} className="w-full max-w-md bg-green-600 hover:bg-green-700 text-white font-black text-xl md:text-2xl py-6 rounded-2xl shadow-[0_20px_50px_rgba(34,197,94,0.3)] mb-8 uppercase tracking-tight" data-id="element-79">
          ⚗️ → QUIERO MI MEGAPACK POR USD 16
        </motion.button>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="flex flex-col items-center gap-4" data-id="element-80">
          <div className="flex items-center gap-2 bg-green-500/10 px-4 py-1.5 rounded-full border border-green-500/20" data-id="element-81">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-82" />
            <span className="text-green-500 text-xs md:text-sm font-black uppercase tracking-widest" data-id="element-83">
              +500 docentes ya lo tienen
            </span>
          </div>
          <p className="text-slate-500 text-[10px] md:text-xs font-bold uppercase tracking-widest" data-id="element-84">
            Acceso digital inmediato · Pago seguro y protegido · Conversión a
            moneda local en el checkout · Garantía de 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}